export default "__VITE_ASSET__DIsNDund__"